import { ColumnsType, InfiniteTable } from '@/components/_common';
import { ListStickerWorkOrdersResponse } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';

import { Card, Typography, Space } from 'antd';
import moment from 'moment';
import { useMemo } from 'react';

const { Text } = Typography;

interface Props {
  restItems?: ListStickerWorkOrdersResponse[];
  loading?: boolean;
  isFetching?: boolean;
  hasNextPage?: boolean;
  fetchNextPage?: VoidFunction;
}

interface ServiceRow {
  key: string;
  complementIdentifier?: string;
  entryDate?: string;
  currentKilometers?: number;
  serviceName?: string;
  nextRevisionInKilometers?: number | string;
  nextRevisionDate?: string;
}

export default function TableServicesPreviouslyPerformed({
  restItems = [],
  ...props
}: Props) {
  const services = useMemo<ServiceRow[]>(() => {
    return restItems?.flatMap((workOrder) =>
      workOrder?.servicesList?.map((service, index) => ({
        key: `${workOrder.workOrderId}-${service.id ?? index}`,
        complementIdentifier: workOrder.complementIdentifier,
        entryDate: workOrder.entryDate,
        currentKilometers: workOrder.currentKilometers,
        serviceName: service.serviceName,
        nextRevisionInKilometers: service.nextRevisionInKilometers,
        nextRevisionDate: service.nextRevisionDate,
      })),
    );
  }, [restItems]);

  const renderDateKm = (date?: string, km?: number) => {
    const formattedDate = date
      ? moment(date).format('DD/MM/YYYY')
      : 'Não informado';

    const formattedKm = km ? `${km} KM` : 'Não informado';

    return (
      <Space direction="vertical" size={0}>
        <Text>{formattedDate}</Text>
        <Text type="secondary">{formattedKm}</Text>
      </Space>
    );
  };

  const columns: ColumnsType<ServiceRow> = [
    {
      title: 'Orçamento',
      dataIndex: 'complementIdentifier',
      key: 'complementIdentifier',
      render: (value) => <Text strong>{value}</Text>,
    },
    {
      title: 'Serviço',
      dataIndex: 'serviceName',
      key: 'serviceName',
      render: (value) => <Text>{value}</Text>,
    },
    {
      title: 'Data/KM da troca',
      render: (item) => renderDateKm(item?.entryDate, item?.currentKilometers),
    },
    {
      title: 'Próxima troca',
      render: (item) =>
        renderDateKm(item?.nextRevisionDate, item?.nextRevisionInKilometers),
    },
  ];

  return (
    <Card type="inner" style={{ borderRadius: 10 }}>
      <InfiniteTable<ServiceRow>
        columns={columns}
        dataSource={services}
        loading={props.loading}
        isFetching={props.isFetching}
        hasNextPage={props.hasNextPage}
        fetchNextPage={props.fetchNextPage}
      />
    </Card>
  );
}
